const adminMenu = [
  {
    header: true,
    title: 'Admin',
  },
  {
    title: 'Painel Administrativo',
    icon: 'setting-3',
    href: '/admin',
  },
  {
    splitter: true,
  },
]

const sharedMenu = [
  {
    header: true,
    title: 'Conta Digital',
  },
  {
    title: 'Home',
    icon: 'house-2',
    href: '/dashboard',
  },
  {
    title: 'Contatos',
    icon: 'profile-2user',
    href: '/contacts',
  },
  {
    title: 'Autorizações',
    icon: 'key',
    href: '/authorize',
    permission: 'can_sign_transaction',
  },
  {
    splitter: true,
  },
  {
    header: true,
    title: 'Operações',
  },
  {
    title: 'Extrato',
    icon: 'receipt-2',
    href: '/statement',
    permission: 'can_see_statement',
  },
  {
    title: 'Depósito',
    icon: 'money-add',
    child: [
      {
        title: 'Boleto Depósito',
        href: '/boleto_deposito',
      },
      {
        title: 'ImoPIX',
        href: '/pix_deposito',
      },
      {
        title: 'Reconhecimento',
        href: '/recognize',
        flag: 'reconhecimento_de_deposito',
      },
    ],
  },
  {
    title: 'Pix',
    icon: 'pix',
    href: '/pix',
    flag: 'pix_transactions',
  },
  {
    title: 'Transferências',
    icon: 'money-send',
    href: '/transfers',
  },
  {
    title: 'Pagamento de contas',
    icon: 'receipt-add',
    href: '/pagamentos',
  },
  {
    title: 'Ordem de pagamento',
    icon: 'ticket',
    href: '/ordens_pagamento',
  },
  {
    title: 'Investimentos',
    icon: 'status-up',
    href: '/investimentos',
    permission: 'can_see_statement',
  },
  // {
  //   title: 'Serviço de Câmbio',
  //   icon: 'bitcoin-convert',
  //   href: '/cambio',
  // },
  {
    splitter: true,
  },
  {
    header: true,
    title: 'Recebíveis',
  },
  {
    title: 'Produtos & Serviços',
    icon: 'box',
    href: '/products',
    flag: 'sale',
  },
  {
    title: 'Vendas',
    icon: 'shop',
    href: '/vendas',
    flag: 'sale',
  },
  {
    title: 'Carteiras',
    icon: 'empty-wallet',
    href: '/wallets',
  },
  {
    icon: 'coin',
    title: 'Recebíveis',
    child: [
      {
        title: 'Títulos',
        href: '/debts/single',
      },
      {
        title: 'Carnês',
        href: '/debts/composite',
      },
      {
        title: 'Contratos',
        href: '/contracts/overview',
      },
      {
        title: 'Importação',
        href: '/debts/import',
      },
    ],
  },
  {
    title: 'Antecipação',
    icon: 'money-recive',
    href: '/antecipacao_welcome',
  },
  {
    title: 'Relatórios',
    icon: 'document-copy',
    href: '/reports',
  },
]

const menu = {
  admin: adminMenu,
  shared: sharedMenu,
}

export default menu
